import {FormGroup, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {Directive, Input} from "@angular/core";
import {EmailValidator} from "./email-validator";

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[emailValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }]
})
export class EmailValidatorDirective implements Validator {

    constructor() { }

    @Input('emailValidator') emailValidator: any[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        return EmailValidator(this.emailValidator[0], this.emailValidator[1], this.emailValidator[2])(formGroup);
    }
}
